function mobileZoom($img, $container) {
    let scale = 1;
    let lastScale = 1;
    let startX = 0, startY = 0;
    let lastX = 0, lastY = 0;
    let isDragging = false;
    let initialDistance = null;
    let doubleTapTimer = null;
  
    function setTransform() {
      $img.css('transform', `translate(${lastX}px, ${lastY}px) scale(${scale})`);
    }
  
    function getDistance(touches) {
      const [a, b] = touches;
      const dx = b.clientX - a.clientX;
      const dy = b.clientY - a.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    
    // Function to perform zoom centered at a specific point
    function zoomToPoint(x, y, newScale) {
      // Get container dimensions
      const containerWidth = $container.width();
      const containerHeight = $container.height();
      
      // Calculate the relative position of the click point within the container
      const containerOffset = $container.offset();
      const pointX = x - containerOffset.left;
      const pointY = y - containerOffset.top;
      
      // Scale factor
      const scaleFactor = newScale / scale;
      
      // Calculate new position to keep the click point in the same visual position
      if (newScale > 1) {
        // Only adjust the position if we are zooming in
        lastX = lastX - (pointX - containerWidth / 2) * (scaleFactor - 1);
        lastY = lastY - (pointY - containerHeight / 2) * (scaleFactor - 1);
      } else {
        // If we zoom out to 1, reset the position
        lastX = 0;
        lastY = 0;
      }
      
      // Update scale
      scale = newScale;
      
      // Limit movement within the container
      const maxX = ($img.width() * scale - $container.width()) / 2;
      const maxY = ($img.height() * scale - $container.height()) / 2;
      lastX = Math.max(-maxX, Math.min(lastX, maxX));
      lastY = Math.max(-maxY, Math.min(lastY, maxY));
      
      setTransform();
    }
    
    // Handle double click for zoom on desktop
    $container.on('dblclick', function(e) {
      e.preventDefault();
      
      if (scale === 1) {
        // Zoom in centered at the click point
        zoomToPoint(e.clientX, e.clientY, 2);
      } else {
        // Zoom out to scale 1
        zoomToPoint(e.clientX, e.clientY, 1);
      }
    });
  
    $container.on('touchstart', function(e) {
      if (e.touches.length === 1) {
        startX = e.touches[0].clientX - lastX;
        startY = e.touches[0].clientY - lastY;
        isDragging = true;
  
        // double tap
        const now = new Date().getTime();
        if (doubleTapTimer && now - doubleTapTimer < 300) {
          // toggle zoom centered at the double tap point
          if (scale === 1) {
            zoomToPoint(e.touches[0].clientX, e.touches[0].clientY, 2);
          } else {
            zoomToPoint(e.touches[0].clientX, e.touches[0].clientY, 1);
          }
          doubleTapTimer = null;
          e.preventDefault();
        } else {
          doubleTapTimer = now;
        }
  
      } else if (e.touches.length === 2) {
        initialDistance = getDistance(e.touches);
        lastScale = scale;
        isDragging = false;
      }
    });
  
    $container.on('touchmove', function(e) {
      if (e.touches.length === 1 && isDragging && scale > 1) {
        lastX = e.touches[0].clientX - startX;
        lastY = e.touches[0].clientY - startY;
  
        // Limit movement within the container
        const maxX = ($img.width() * scale - $container.width()) / 2;
        const maxY = ($img.height() * scale - $container.height()) / 2;
        lastX = Math.max(-maxX, Math.min(lastX, maxX));
        lastY = Math.max(-maxY, Math.min(lastY, maxY));
  
        setTransform();
      } else if (e.touches.length === 2) {
        const newDistance = getDistance(e.touches);
        const delta = newDistance - initialDistance;
        scale = Math.min(3, Math.max(1, lastScale + delta / 200));
        setTransform();
      }
  
      e.preventDefault();
    });
  
    $container.on('touchend', function(e) {
      if (e.touches.length === 0) {
        isDragging = false;
      }
    });
    
    // Add support for dragging with the mouse
    $container.on('mousedown', function(e) {
      if (scale > 1) {
        startX = e.clientX - lastX;
        startY = e.clientY - lastY;
        isDragging = true;
        e.preventDefault();
      }
    });
    
    $(document).on('mousemove', function(e) {
      if (isDragging && scale > 1) {
        lastX = e.clientX - startX;
        lastY = e.clientY - startY;
        
        // Limit movement within the container
        const maxX = ($img.width() * scale - $container.width()) / 2;
        const maxY = ($img.height() * scale - $container.height()) / 2;
        lastX = Math.max(-maxX, Math.min(lastX, maxX));
        lastY = Math.max(-maxY, Math.min(lastY, maxY));
        
        setTransform();
        e.preventDefault();
      }
    });
    
    $(document).on('mouseup', function() {
      isDragging = false;
    });
}
module.exports = mobileZoom;